module.exports = __webpack_public_path__ + "media/images/homepage/slider1-6ea0be12ce0e208cb418721ab5604a63.png";